import { render, staticRenderFns } from "./AdminPanel.vue?vue&type=template&id=497b3052&scoped=true"
import script from "./AdminPanel.vue?vue&type=script&lang=js"
export * from "./AdminPanel.vue?vue&type=script&lang=js"
import style0 from "./AdminPanel.vue?vue&type=style&index=0&id=497b3052&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497b3052",
  null
  
)

export default component.exports